import React, { useRef, useState } from 'react';
import { Button } from "react-bootstrap";
import chiediConferma from '../Util/chiediConferma';

const ESTENSIONI = ['.png', '.jpg', '.jpeg', '.svg'];
const MAX_BYTES = 2 * 1024 * 1024;

/**
 * Box di caricamento della firma digitale, condiviso da scheda e pagina firma.
 *
 * Restituisce al chiamante `{ content, name }` con il contenuto in base64, che è
 * il formato accettato dall'endpoint. La stessa validazione gira anche lato
 * backend: questa serve solo a dare un errore immediato.
 */
export const FirmaUpload = ({ firmaCorrente, onSelezione, onRimuovi, onErrore }) => {

	const inputRef = useRef(null);
	const [anteprima, setAnteprima] = useState(null);
	const [nomeFile, setNomeFile] = useState(null);

	const uriCorrente = firmaCorrente && firmaCorrente.uri ? firmaCorrente.uri : null;
	const haFirma = !!(anteprima || uriCorrente);

	const scegli = (e) => {
		const file = e.target.files && e.target.files[0];
		if (!file) return;

		const nome = file.name.toLowerCase();
		if (!ESTENSIONI.some(ext => nome.endsWith(ext))) {
			onErrore('Formati supportati: PNG, JPG, SVG.');
			return;
		}
		if (file.size > MAX_BYTES) {
			onErrore('La firma non può superare i 2 MB.');
			return;
		}

		const reader = new FileReader();
		reader.onload = () => {
			// `readAsDataURL` produce "data:<mime>;base64,<contenuto>": al backend
			// va solo la parte dopo la virgola.
			const dataUrl = String(reader.result);
			setAnteprima(dataUrl);
			setNomeFile(file.name);
			onSelezione({ content: dataUrl.split(',')[1], name: file.name });
		};
		reader.readAsDataURL(file);
	};

	const rimuovi = async () => {
		if (!(await chiediConferma({ titolo: 'Togliere la firma?', testo: 'La firma sparisce dalla scheda.' }))) return;
		setAnteprima(null);
		setNomeFile(null);
		if (inputRef.current) inputRef.current.value = '';
		onRimuovi();
	};

	return (
		<div className="sid-firma-box">
			<input
				ref={inputRef}
				type="file"
				accept="image/png,image/jpeg,image/svg+xml"
				style={{ display: 'none' }}
				onChange={scegli}
			/>

			<div className="sid-firma-preview">
				{haFirma
					? <img src={anteprima || uriCorrente} alt={nomeFile || 'Firma digitale'} />
					: <span className="sid-firma-empty">Nessuna firma caricata</span>}
			</div>

			<div className="d-flex gap-2 align-items-center flex-wrap">
				<Button className="btn btn-add sid-btn-secondary" onClick={() => inputRef.current && inputRef.current.click()}>
					{haFirma ? 'Sostituisci file' : 'Scegli file'}
				</Button>
				{haFirma && (
					<Button variant="link" className="text-muted p-1" onClick={rimuovi}>Rimuovi</Button>
				)}
				{nomeFile && <span className="sid-firma-empty">{nomeFile}</span>}
			</div>

			<p className="sid-firma-hint">
				Formati supportati: PNG, JPG, SVG · dimensione massima 2 MB · sfondo trasparente consigliato.
			</p>
		</div>
	);
};

export default FirmaUpload;
